import type { EventItem } from '@/types/events';

export const ALL_EVENTS: EventItem[] = [
    {
        id: 'zero-expert-workshop-brno-2',
        date: 'November 29, 2025 (17:00–20:00)',
        city: 'Brno, Czech Republic',
        title: 'ZeroClub Expert Workshop',
        type: 'Expert Workshop',
        intro: 'What’s slowing your business down? A practical session on finding and fixing hidden process problems.',
        description:
            'Learn how inefficient processes silently block growth, waste time, and drain money. Business analyst Mikhail Monashev will show you simple ways to identify performance leaks, optimize your workflow, and make your business run smoother — even if you have no technical background.',
        bullets: [
            'Talk by process analysis expert Mikhail Monashev',
            'Understand where your time and money are disappearing',
            'Practical tools to fix slowdowns in your business',
            'Networking with founders and professionals at Clubco'
        ],
        imageUrl: '/speaker.png',
        imageAlt: 'Mikhail Monashev – ZeroClub Expert Workshop in Brno',
        speakerName: 'Mikhail Monashev',
        speakerTitle: 'Business Process Analyst',

        speakerHighlights: [
            'PhD degree in Business Economy',
            '5+ years of experience in business process analysis',
        ],
    },

];

export const getEventById = (id: string) => ALL_EVENTS.find(e => e.id === id);
